module.exports = __webpack_public_path__ + "static/media/ErrorIcon.5084cee2.svg";